import axios from "@/lib/axios";
import { Regime } from "@/types/company";
import {
  DimensionsSummary,
  QuestionnaireResultStatus,
  QuizStatus,
} from "@/types/questionnaries";

export type QuizByIdRequestParams = {
  companyId: string;
  applicationQuizId: string;
};

export type Applicant = {
  id: string;
  applicationId: string;
  name: string;
  regime: Regime;
  sector: {
    id: string;
    name: string;
  };
  subsector: {
    id: string;
    name: string;
  };
};

export type Edition = {
  id: string;
  year: number;
  name: string;
};

export type QuizSummary = {
  dimensionsCount: number;
  completedDimensionsCount: number;
  topicsCount: number;
  completedTopicsCount: number;
  totalQuestionsCount: number;
  respondedQuestionsCount: number;
  completedQuestionsCount: number;
  completedQuestionsPercentage: number;
  respondedQuestionsPercentage: number;
};

export type QuizByIdResponse = {
  id: string;
  status: QuizStatus;
  applicant: Applicant;
  edition: Edition;
  summary: QuizSummary;
  dimensionsSummary: DimensionsSummary[];
  result: {
    color: string;
    resultStatus: QuestionnaireResultStatus;
    score: 1.31;
  };
  conclusions: string | null;
  appealReviewCount: number;
};

export const quizById = async (params: QuizByIdRequestParams) =>
  axios
    .get<QuizByIdResponse>(
      `/v1/companies/${params.companyId}/application-quizzes/${params.applicationQuizId}`,
    )
    .then((res) => res.data);
